/*************************
 * @license
 * Copyright 2024 Myenergi Ltd. All rights reserved.
 * No part of this work may be reproduced, stored in a retrieval system of any nature, or transmitted, in any form or by any means without the prior written permission of Myenergi Ltd., the copyright owner.
 * If any unauthorised acts are carried out in relation to this copyright work, a civil claim for damages may be made and/or a criminal prosecution may result.
 *************************/
import { action, makeObservable, observable } from "mobx";
import { persist } from "mobx-persist";
import { DsrSearch } from "models/dsrgraphql";

export class DsrSearchStore {
  @observable @persist("object") public dsrSearchResult: DsrSearch | undefined;
  @observable @persist public isLoading = false;

  constructor() {
    makeObservable(this);
  }

  @action.bound
  public setIsLoading(isLoading: boolean): void {
    if (isLoading) {
      this.dsrSearchResult = undefined;
    }

    this.isLoading = isLoading;
  }

  @action.bound
  public setDsrSearchResult(searchResult: DsrSearch): void {
    this.dsrSearchResult = searchResult;
  }
}

export default DsrSearchStore;
